<template>
  <div class="librarydetails">
      <div class="top">
      <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
    </div>
    <div class="mainWrap" :style="`height:${windowHeight-210}px`">
      <div style="width: 810px; margin: 0 auto;overflow: hidden;">
        <image-previewer tag="richtext">
          <el-form :model="ruleForm" ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <el-form-item label="封面">
              <img class="img" :src="ruleForm.coverUrl" alt="">
            </el-form-item>
            <el-form-item label="" v-for="(item,index) in ruleForm.fileJson" :key="index">
              <a :href="item.accessUrl" :download="item.fileName">{{item.fileName}}</a>
            </el-form-item>
            <el-form-item label="书籍名称">
              {{ruleForm.boolName}}
            </el-form-item>
            <el-form-item label="书籍类别">
              {{ruleForm.typeName}}
            </el-form-item>
            <el-form-item label="书籍内容">
              {{ruleForm.content}}
            </el-form-item>
            <el-form-item label="书籍介绍">
              <div v-html="ruleForm.introduce"></div>
            </el-form-item>
          </el-form>
        </image-previewer>
      </div>
    </div>
  </div>
</template>

<script>
  import BackTool from "@/components/BackTool";
  import mixin from "@/mixins/windowResize";
  import {getPlayWordBookById} from "@/api/library";
  import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';

  export default {
    name: "libraryDetail",
    components: {
      BackTool,
      ImagePreviewer
    },
    data() {
      return {
        ruleForm: {
          boolName: "",
          content: "",
          coverUrl: "",
          introduce: "",
          typeName: "",
          id: this.$route.query.id
        }
      };
    },
    mixins: [mixin],
    created() {
      this.getPlayWordBookByIds();
    },
    methods: {
      //获取详情
      getPlayWordBookByIds() {
        getPlayWordBookById(this.ruleForm.id).then(res => {
          let data = res.data.data;
          this.ruleForm.boolName = data.boolName;
          this.ruleForm.content = data.content;
          this.ruleForm.introduce = data.introduce;
          this.ruleForm.coverUrl = data.coverUrl;
          this.ruleForm.typeName = data.typeName;
          this.ruleForm.fileJson = data.playWordBookFileList;
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import './../../../styles/mixin';
  .librarydetails {
    padding: 12px;
    box-sizing: border-box;

    .mainWrap {
      padding: 20px 10px;
      @include scrollBar;
    }
     .top{
       border-bottom: 1px solid #e7eaec;
      padding-bottom: 10px;
    }
    .img {
      width: 140px;
      height: 200px;
    }

    a {
      color: #409EFF;
    }
  }
</style>
<style>
  .librarydetails img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/study/library/libraryDetail.vue